import { ContentItemTypes } from 'modules/Boards/Types';
import AddToMyBoards from '../components/addToMyBoards';

const addToBoardBtns = document.querySelectorAll('.save-board-btn');

function addToBoard(e) {
  const title = e.currentTarget.getAttribute('data-blog-title');
  AddToMyBoards.openModal(ContentItemTypes.article, null, null, title);
}

addToBoardBtns.forEach((el) => {
  $(el).on('click', addToBoard);
});
